// extracted by css-extract-rspack-plugin
export default {"form":"form-qnHouS","fieldsContainer":"fieldsContainer-Q6EQS4","field":"field-F_iS_w"};